

function changeDisplayedArt(newArtLink) {
    console.log("Changing displayed art to " + newArtLink);
    var artDisplay = document.getElementById("art-display");
    var artLink = document.getElementById("art-link");
    artDisplay.src = "/assets/img/art-archive/" + newArtLink;
    artLink.href = "/assets/img/art-archive/" + newArtLink;
}

function changeArtAndHighlight(button, newArtLink) {
    changeDisplayedArt(newArtLink);
    var buttons = document.getElementById("button-parent").children; 

    for (const otherButton of buttons) { 
        otherButton.classList.remove("selected");
        otherButton.classList.add("unselected");
    }

    button.classList.add("selected");
    button.classList.remove("unselected");
}


function preloadImages(imgs) {
    imgs.forEach((img) => {var temp=new Image();
    temp.src=img;});
}

// Give window permission to use the relevant functions.
Object.assign(window, {
    changeArtAndHighlight,
    preloadImages
});